export const noticeAlert =
  "প্রিয় গ্রাহক, ওয়েবসাইট থেকে অর্ডার করতে না পারলে অথবা না চাইলে হোয়াটসাপে যোগাযোগ করুন। WhatsApp- 01833534123 (SMS only)";


export const faqItems = [
  {
    id: "NOISBNOIBOIASBF",
    question: "Delivary pete koto shomoy lagbe?",
    answer:
      "About 5-10 minutes per order. but you can ask in whatsapp for fast delivery",
    category: "Pubg",
  },
  {
    id: "NOISABNOIBOISBF",
    question: "Prime Plus ki pawa zay?",
    answer:
      "About 5-10 minutes per order. but you can ask in whatsapp for fast delivery",
    category: "Pubg",
  },
  {
    id: "NOIOISBNBOIASBF",
    question: "Delivary pete koto shomoy lagbe?",
    answer:
      "About 5-10 minutes per order. but you can ask in whatsapp for fast delivery",
    category: "Pubg",
  },
  {
    id: "NOISBNIAOIBOSBF",
    question: "Prime Plus ki pawa zay?",
    answer:
      "About 5-10 minutes per order. but you can ask in whatsapp for fast delivery",
    category: "Pubg",
  },
  {
    id: "NOIBOIASOISBNBF",
    question: "Delivary pete koto shomoy lagbe?",
    answer:
      "About 5-10 minutes per order. but you can ask in whatsapp for fast delivery",
    category: "Free fire",
  },
  {
    id: "NOIBNOISBOIASBF",
    question: "Free Fire Plus ki pawa zay?",
    answer:
      "About 5-10 minutes per order. but you can ask in whatsapp for fast delivery",
    category: "Free fire",
  },
  {
    id: "NOISBIBOIANOSBF",
    question: "Delivary pete koto shomoy lagbe?",
    answer:
      "About 5-10 minutes per order. but you can ask in whatsapp for fast delivery",
    category: "Free fire",
  },
  {
    id: "NOIOBOIISBNASBF",
    question: "Prime Plus ki pawa zay?",
    answer:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
    category: "Free fire",
  },
];

export const monthlist = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
